import React from 'react';
import { Svg, ISvg } from '../Svg';

export const Legacy: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 50 50" fill="none" {...props}>
    <path
      d="M13.2708 19.8123C4.77085 20.4165 4.79168 32.7289 13.2708 33.3331H33.3959C35.8334 33.3539 38.1875 32.4373 40 30.7915C45.9584 25.5832 42.7709 15.1664 34.9167 14.1664C32.1042 -2.79192 7.5417 3.64562 13.3542 19.8123"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 33.334V39.584"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 47.9173C27.3012 47.9173 29.1667 46.0518 29.1667 43.7507C29.1667 41.4495 27.3012 39.584 25 39.584C22.6988 39.584 20.8333 41.4495 20.8333 43.7507C20.8333 46.0518 22.6988 47.9173 25 47.9173Z"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.5 43.75H29.1667"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.8333 43.75H12.5"
      stroke="#737BF8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
